import { withStyles } from "@material-ui/styles";

// ----------------------------------------------------------------------

const GlobalStyles = withStyles((theme) => ({
  "@global": {
    "*": {
      margin: 0,
      padding: 0,
      boxSizing: "border-box"
    },
    html: {
      width: "100%",
      height: "100%",
      // Disable mobile browsers' "smart" text auto-inflation. Without
      // these, iOS Safari and Android Chrome default to
      // `text-size-adjust: auto` and silently inflate body text inside
      // column-narrow layouts (e.g. the 794px-wide signature doc when
      // viewed on a mobile-width screen). Text grows by ~1.2-1.5x,
      // paragraph heights grow with it, but absolutely-positioned
      // template fields stay at their authored pixel coordinates — so
      // fields visibly drift relative to the text on mobile.
      // The `-ms-` prefix only covers legacy Edge; without webkit +
      // standard, the actual mobile browsers customers use are not
      // covered.
      "-webkit-text-size-adjust": "100%",
      "-ms-text-size-adjust": "100%",
      textSizeAdjust: "100%",
      "-webkit-overflow-scrolling": "touch"
    },
    body: {
      width: "100%",
      height: "100%"
    },
    "#root": {
      width: "100%",
      height: "100%"
    },
    input: {
      "&[type=number]": {
        MozAppearance: "textfield",
        "&::-webkit-outer-spin-button": { margin: 0, WebkitAppearance: "none" },
        "&::-webkit-inner-spin-button": { margin: 0, WebkitAppearance: "none" }
      }
    },
    textarea: {
      "&::-webkit-input-placeholder": { color: theme.palette.text.disabled },
      "&::-moz-placeholder": { opacity: 1, color: theme.palette.text.disabled },
      "&:-ms-input-placeholder": { color: theme.palette.text.disabled },
      "&::placeholder": { color: theme.palette.text.disabled }
    },
    a: { color: theme.palette.primary.main },
    img: { display: "block", maxWidth: "100%" },

    // Lazy Load Img
    ".blur-up": {
      WebkitFilter: "blur(5px)",
      filter: "blur(5px)",
      transition: "filter 400ms, -webkit-filter 400ms"
    },
    ".blur-up.lazyloaded ": {
      WebkitFilter: "blur(0)",
      filter: "blur(0)"
    }
  }
}))(() => null);

export default GlobalStyles;
